import moment from "moment";
import React, { Component, useEffect } from "react";
import { useState, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import { MdModeEditOutline, MdModeEdit, MdDelete } from "react-icons/md";
import EditModal from "./EditModal";
const DateModal = ({
  showDateModal,
  handleClose,
  dateModalDetails,
  selectedId,
  handleEdit,
  flightData,
  showEditModal,
  handleDelete,
}) => {
  // console.log(selectedId);

  return (
    <Fragment>
      <Modal
        show={showDateModal}
        size="lg"
        scrollable={true}
        style={showEditModal ? { zIndex: "1040" } : ""}
      >
        <Modal.Header style={{ backgroundColor: "#663399", color: "white" }}>
          <Modal.Title>Dates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="modal-body" id="printModal">
              <div className="col-12">
                <table className="table table-striped border text-center table-inverse">
                  <thead className="thead-inverse text-primary">
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Departure Time</th>
                      <th scope="col">Arrival Time</th>
                      <th scope="col">Seat</th>
                      <th scope="col">PNR</th>
                      <th scope="col"> Edit</th>
                      <th scope="col"> Delete</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {Object.keys(dateModalDetails ?? {}).length !== 0 &&
                      dateModalDetails?.charterFlights.map((item) => (
                        <tr key={item?.id}>
                          <td scope="row">
                            {moment(item?.flightDate).format("DD/MM/YYYY")}
                          </td>

                          <td scope="row">{item?.departureTime}</td>
                          <td scope="row">{item?.arrivalTime}</td>
                          <td scope="row">{item?.seat}</td>
                          <td scope="row">{item?.pnr}</td>

                          <td>
                            <MdModeEdit
                              className="text-success cursor-pointer"
                              size={18}
                              onClick={() => {
                                handleEdit(item.flightDate.split("T")[0]);
                              }}
                            />
                          </td>
                          <td>
                            <MdDelete
                              className="text-danger cursor-pointer"
                              size={18}
                              onClick={() => {
                                handleDelete(item.id);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default DateModal;
